import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { decisionList, taskItem, taskList } from '@atlaskit/adf-schema';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { MAX_INDENTATION_LEVEL } from '@atlaskit/editor-common/indentation';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { toolbarInsertBlockMessages as insertBlockMessages } from '@atlaskit/editor-common/messages';
import { IconAction, IconDecision } from '@atlaskit/editor-common/quick-insert';
import { TaskDecisionSharedCssClassName } from '@atlaskit/editor-common/styles';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { decisionItemSpecWithFixedToDOM } from './nodeviews/toDOM-fixes/decisionItem';
import { getCurrentIndentLevel, getTaskItemIndex, isInsideTask } from './pm-plugins/helpers';
// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import inputRulePlugin from './pm-plugins/input-rules';
import { getListTypes, insertTaskDecisionAction, insertTaskDecisionCommand, setProvider as _setProvider } from './pm-plugins/insert-commands';
import keymap, { getIndentCommand, getUnindentCommand } from './pm-plugins/keymaps';
import { createPlugin } from './pm-plugins/main';
import { stateKey as taskPluginKey } from './pm-plugins/plugin-key';
import ToolbarDecision from './ui/ToolbarDecision';
import ToolbarTask from './ui/ToolbarTask';
var taskDecisionToolbarGroupStyles = css({
  display: 'flex'
});
// @nodeSpecException:toDOM patch
export var taskItemSpecWithFixedToDOM = function taskItemSpecWithFixedToDOM() {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return taskItem;
  }
  return _objectSpread(_objectSpread({}, taskItem), {}, {
    toDOM: function toDOM(node) {
      var checked = node.attrs.state === 'DONE';
      var inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
      };
      if (checked) {
        inputAttrs.checked = 'true';
      }
      var dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state
      };
      return ['div', _objectSpread(_objectSpread({
        class: TaskDecisionSharedCssClassName.TASK_CONTAINER
      }, dataAttrs), {}, {
        style: convertToInlineCss({
          listStyleType: 'none',
          lineHeight: '24px',
          minWidth: '48px',
          position: 'relative'
        })
      }), ['div', {
        style: convertToInlineCss({
          display: 'flex'
        })
      }, ['span', {
        contenteditable: 'false',
        style: convertToInlineCss({
          width: '24px',
          height: '24px',
          lineHeight: '24px',
          display: 'grid',
          placeContent: 'center center'
        })
      }, ['input', _objectSpread(_objectSpread({}, inputAttrs), {}, {
        'data-input-type': 'lazy-task-item',
        style: convertToInlineCss({
          width: '13px',
          height: '13px',
          margin: '1px 0 0 0',
          padding: 0,
          accentColor: "var(--ds-background-selected-bold, #0C66E4)"
        })
      })]], ['div', {
        'data-component': 'content'
      }, ['div', {
        class: TaskDecisionSharedCssClassName.TASK_ITEM,
        style: convertToInlineCss({
          display: 'block',
          fontSize: '16px',
          fontFamily: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
          color: "var(--ds-text, #172B4D)"
        })
      }, 0]]]];
    }
  });
};
var addItem = function addItem(insert, listType, schema) {
  return function (_ref) {
    var listLocalId = _ref.listLocalId,
      itemLocalId = _ref.itemLocalId;
    var _getListTypes = getListTypes(listType, schema),
      list = _getListTypes.list,
      item = _getListTypes.item;
    return insert(list.createChecked({
      localId: listLocalId
    }, item.createChecked({
      localId: itemLocalId
    })));
  };
};
export var tasksAndDecisionsPlugin = function tasksAndDecisionsPlugin(_ref2) {
  var _api$analytics, _api$analytics2, _api$analytics3;
  var _ref2$config = _ref2.config,
    _ref2$config2 = _ref2$config === void 0 ? {} : _ref2$config,
    allowNestedTasks = _ref2$config2.allowNestedTasks,
    consumeTabs = _ref2$config2.consumeTabs,
    useLongPressSelection = _ref2$config2.useLongPressSelection,
    _ref2$config2$hasEdit = _ref2$config2.hasEditPermission,
    hasEditPermission = _ref2$config2$hasEdit === void 0 ? true : _ref2$config2$hasEdit,
    hasRequestedEditPermission = _ref2$config2.hasRequestedEditPermission,
    quickInsertActionDescription = _ref2$config2.quickInsertActionDescription,
    requestToEditContent = _ref2$config2.requestToEditContent,
    taskDecisionProvider = _ref2$config2.taskDecisionProvider,
    taskPlaceholder = _ref2$config2.taskPlaceholder,
    api = _ref2.api;
  var getIdentifierProvider = function getIdentifierProvider() {
    var _api$contextIdentifie;
    return api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 || (_api$contextIdentifie = _api$contextIdentifie.sharedState.currentState()) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.contextIdentifierProvider;
  };
  var previousTaskAndDecisionProvider;
  if (taskDecisionProvider) {
    taskDecisionProvider.then(function (provider) {
      api === null || api === void 0 || api.core.actions.execute(function (_ref3) {
        var tr = _ref3.tr;
        return _setProvider(provider)(tr);
      });
    });
  }
  return {
    name: 'taskDecision',
    nodes: function nodes() {
      return [{
        name: 'decisionList',
        node: decisionList
      }, {
        name: 'decisionItem',
        node: decisionItemSpecWithFixedToDOM()
      }, {
        name: 'taskList',
        node: taskList
      }, {
        name: 'taskItem',
        node: taskItemSpecWithFixedToDOM()
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      var pluginState = taskPluginKey.getState(editorState);
      var indentLevel = getCurrentIndentLevel(editorState.selection) || 0;
      var itemIndex = getTaskItemIndex(editorState);
      return {
        focusedTaskItemLocalId: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.focusedTaskItemLocalId) || null,
        isInsideTask: isInsideTask(editorState),
        indentDisabled: itemIndex === 0 || indentLevel >= MAX_INDENTATION_LEVEL,
        outdentDisabled: indentLevel <= 1,
        // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
        // this allows the default plugin state to initialise as true if the extra configuration is not provided
        hasEditPermission: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasEditPermission) !== undefined ? pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasEditPermission : true,
        requestToEditContent: pluginState === null || pluginState === void 0 ? void 0 : pluginState.requestToEditContent,
        hasRequestedEditPermission: pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasRequestedEditPermission,
        taskDecisionProvider: pluginState === null || pluginState === void 0 ? void 0 : pluginState.taskDecisionProvider
      };
    },
    commands: {
      updateEditPermission: function updateEditPermission(hasEditPermission) {
        return function (_ref4) {
          var tr = _ref4.tr;
          return tr.setMeta(taskPluginKey, {
            hasEditPermission: hasEditPermission
          });
        };
      },
      updateHasRequestedEditPermission: function updateHasRequestedEditPermission(hasRequestedEditPermission) {
        return function (_ref5) {
          var tr = _ref5.tr;
          return tr.setMeta(taskPluginKey, {
            hasRequestedEditPermission: hasRequestedEditPermission
          });
        };
      }
    },
    actions: {
      insertTaskDecision: insertTaskDecisionCommand(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, getIdentifierProvider),
      indentTaskList: getIndentCommand(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions),
      outdentTaskList: getUnindentCommand(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions),
      setProvider: function () {
        var _setProvider2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(providerPromise) {
          var _api$core$actions$exe;
          var provider;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return providerPromise;
              case 2:
                provider = _context.sent;
                if (!(previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", false);
              case 5:
                previousTaskAndDecisionProvider = provider;
                return _context.abrupt("return", (_api$core$actions$exe = api === null || api === void 0 ? void 0 : api.core.actions.execute(function (_ref6) {
                  var tr = _ref6.tr;
                  return _setProvider(provider)(tr);
                })) !== null && _api$core$actions$exe !== void 0 ? _api$core$actions$exe : false);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function setProvider(_x) {
          return _setProvider2.apply(this, arguments);
        }
        return setProvider;
      }()
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'tasksAndDecisions',
        plugin: function plugin(_ref7) {
          var portalProviderAPI = _ref7.portalProviderAPI,
            providerFactory = _ref7.providerFactory,
            eventDispatcher = _ref7.eventDispatcher,
            dispatch = _ref7.dispatch;
          return createPlugin(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder !== undefined && editorExperiment('issue_view_action_items', true) ? taskPlaceholder : undefined);
        }
      }, {
        name: 'tasksAndDecisionsInputRule',
        plugin: function plugin(_ref8) {
          var _api$analytics4;
          var schema = _ref8.schema,
            featureFlags = _ref8.featureFlags;
          return inputRulePlugin(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, getIdentifierProvider)(schema, featureFlags);
        }
      }, {
        name: 'tasksAndDecisionsKeyMap',
        plugin: function plugin(_ref9) {
          var schema = _ref9.schema;
          return keymap(schema, api, allowNestedTasks, consumeTabs);
        }
      } // Needs to be after "save-on-enter"
      ];
    },
    secondaryToolbarComponent: function secondaryToolbarComponent(_ref10) {
      var editorView = _ref10.editorView,
        disabled = _ref10.disabled;
      return jsx("div", {
        css: taskDecisionToolbarGroupStyles
      }, jsx(ToolbarDecision, {
        editorView: editorView,
        isDisabled: disabled,
        isReducedSpacing: true,
        editorAPI: api
      }), jsx(ToolbarTask, {
        editorView: editorView,
        isDisabled: disabled,
        isReducedSpacing: true,
        editorAPI: api
      }));
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref11) {
        var formatMessage = _ref11.formatMessage;
        return [{
          id: 'action',
          title: formatMessage(insertBlockMessages.action),
          description: quickInsertActionDescription !== undefined && editorExperiment('issue_view_action_items', true) ? quickInsertActionDescription : formatMessage(insertBlockMessages.actionDescription),
          priority: 100,
          keywords: ['checkbox', 'task', 'todo'],
          keyshortcut: '[]',
          icon: function icon() {
            return jsx(IconAction, null);
          },
          action: function action(insert, state) {
            var _api$analytics5;
            return insertTaskDecisionAction(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, getIdentifierProvider)(state, 'taskList', INPUT_METHOD.QUICK_INSERT, addItem(insert, 'taskList', state.schema));
          }
        }, {
          id: 'decision',
          title: formatMessage(insertBlockMessages.decision),
          description: formatMessage(insertBlockMessages.decisionDescription),
          priority: 900,
          keyshortcut: '<>',
          icon: function icon() {
            return jsx(IconDecision, null);
          },
          action: function action(insert, state) {
            var _api$analytics6;
            return insertTaskDecisionAction(api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions, getIdentifierProvider)(state, 'decisionList', INPUT_METHOD.QUICK_INSERT, addItem(insert, 'decisionList', state.schema));
          }
        }];
      }
    }
  };
};